import React from 'react';

import {HStack} from '../../../layout/layout.styled';
import {SelectFormControl} from '../../../forms/select-form-control/select-form-control';

export type FilterItem = {
    labelText: string
    value: string
}

export type FilterMenuProps = {
    onSetSettingFilter: (setting: string) => any
    onSetRegionFilter: (region: string) => any
    regionMenuItems: Array<FilterItem>
}

export const FilterMenu = ({
    regionMenuItems,
    onSetRegionFilter,
    onSetSettingFilter
}: FilterMenuProps) => {
    const handleSetRegionFilter = (
        event: React.ChangeEvent<{name?: string; value: unknown}>
    ) => {
        if (typeof event.target?.value === 'string') {
            onSetRegionFilter(event.target.value);
        }
    };

    const handleSetRegionOrSchoolSettingFilter = (
        event: React.ChangeEvent<{name?: string; value: unknown}>
    ) => {
        if (typeof event.target?.value === 'string') {
            onSetSettingFilter(event.target.value);
        }
    };

    return (
        <HStack spacing={'20px'} data-testid={'FilterControls'}>
            <SelectFormControl
                data-testid={'FilterByRegion'}
                labelText={'Filter by region'}
                menuItems={regionMenuItems}
                selectProps={{
                    onChange: handleSetRegionFilter
                }}
                stackProps={{
                    style: {
                        minWidth: 200
                    }
                }}
            />

            <SelectFormControl
                data-testid={'FilterRegionOrSchoolSetting'}
                labelText={'Region or School setting'}
                menuItems={[
                    {labelText: 'Region', value: 'Region'},
                    {labelText: 'School', value: 'School'}
                ]}
                selectProps={{
                    onChange: handleSetRegionOrSchoolSettingFilter
                }}
                stackProps={{
                    style: {
                        minWidth: 200
                    }
                }}
            />
        </HStack>
    );
};
